import { LanguageStringItem, LanguageStringItems } from "../dataTypes/LanguageStringItem"

export const langAvailable = ['de','en']
export var   curLang = 'de'

var currentStringList:{[key:string]: LanguageStringItem} = {}

export const setLocalStrings = (list:LanguageStringItems) => {
  currentStringList = {...currentStringList,...list}
  //console.log('NEW STRING DATA',currentStringList)
}

export const testStr = (id:any) => {
  if (String(id).charAt(0) === '$') id = String(id).substring(1)
  if (currentStringList[id] && currentStringList[id][curLang]){
    return true
  }else{
    return false
  }
}

export const getStr = (id:any,defaultValue?:any) => {
  //console.log('GETSTRING',id, currentStringList[id])
  if (String(id).charAt(0) === '$') id = String(id).substring(1)

  if (currentStringList[id] && currentStringList[id][curLang]){
    return currentStringList[id][curLang]
  }else{
    return id
  }
}


export const getVoice = (id:any, defaultValue?:any) => {
  if (String(id).charAt(0) === '$') id = String(id).substring(1)
  console.log('GETTING VOIE',id,currentStringList[id])
  if (currentStringList[id] && currentStringList[id]['voice']){
    return currentStringList[id]['voice']
  }else{
    return defaultValue;
  }
}

export const setStr = (id:any, val:any) => {

  if (currentStringList[id]){
    currentStringList[id][curLang] = val.text
  }else{
    currentStringList[id] = {
      id: id,
      de: val
    }
  }
  
}